import { render, staticRenderFns } from "./Gorgias.vue?vue&type=template&id=d65fcfca&"
import script from "./Gorgias.vue?vue&type=script&lang=js&"
export * from "./Gorgias.vue?vue&type=script&lang=js&"
import style0 from "./Gorgias.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports